import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import HttpBackend from 'i18next-http-backend';
import en from './i18n/locales/en/translation.json';
import fr from './i18n/locales/fr/translation.json';
import nl from './i18n/locales/nl/translation.json';

i18n
  //.use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: false,
    defaultNS: 'translation',
    ns: ['translation'],
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      nl: { translation: nl },
    },
    backend: {
      loadPath: '/i18n/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;